var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5,5.2H6.5c-1.1,0-2,0.9-2,2v7.4c0,1.1,0.9,2,2,2h2.8l2.1,1.9c0.1,0.1,0.3,0.2,0.5,0.2 c0.2,0,0.4-0.1,0.5-0.2l2-1.9c0.8,0,2.8,0,2.9,0c0,0,0,0,0,0c1.1,0,2-0.9,2-2V7.3C19.5,6.2,18.6,5.2,17.5,5.2z M18,14.7 c0,0.3-0.2,0.5-0.5,0.5v0.1c-0.6-0.1-1.5-0.1-3.2-0.1c-0.2,0-0.4,0.1-0.5,0.2L12,17l-1.8-1.6c-0.1-0.1-0.3-0.2-0.5-0.2H6.5 C6.2,15.2,6,15,6,14.7V7.3C6,7,6.2,6.7,6.5,6.7h10.9C17.8,6.7,18,7,18,7.3V14.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.300b0f29d500653bf806e5eaac931846.svg";
export { ForwardRef as ReactComponent };